<div class="mw howItWorks">
    <div class="row">
        <div class="xl-12">
            <h2>{{ 'static.howItWorks' | translate }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/hand.svg"/>
            <img *ngIf="brand === 'winaija'" src="../../../assets/images/how-it-works/ico_chooseTheLotto-Winaija.svg"/>
            <h3>{{ 'static.ctl' | translate }}</h3>
            <p>{{ 'static.ctlBody' | translate }}</p>
        </div>
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/lotto.svg"/>
            <img *ngIf="brand === 'winaija'" src="../../../assets/images/how-it-works/ico_play-Winaija.svg"/>
            <h3>{{ 'static.play' | translate }}</h3>
            <p>{{ 'static.playBody' | translate }}</p>
        </div>
        <div class="fl xs-12 sm-4 md-4 xl-4">
            <img *ngIf="brand === 'qiwi'" src="../../../assets/images/newCircleIcons/dollar.svg"/>
            <img *ngIf="brand === 'winaija'" src="../../../assets/images/how-it-works/ico_win-Winaija.svg"/>
            <h3>{{ 'static.win' | translate }}</h3>
            <p>{{ 'static.winBody' | translate }}</p>
        </div>
    </div>
</div>
